import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowCornerUpRight = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21.5 16H8L8 2.5", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M17 11.5L21.5 16L17 20.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M3.5 7L8 2.5L12.5 7", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconArrowCornerUpRight.js.map